import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useInterestsState() {
  return useAppState();
}

export function useInterestsActions() {
  const dispatch = useAppDispatch();

  function initializeState(authenticatedUser) {
    dispatch((appState) => ({
      ...appState,
      loading: true,
      authenticatedUser,
      pageNumber: 1,
      numberOfPages: 1,
      interests: [],
      newUnrecognizedInterestForm: {
        interestName: '',
        debouncedInterestNameForFuzzyFilter: '',
      },
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({ ...appState, ...response }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback }));
  }

  function updateNewInterestName(interestName) {
    dispatch((appState) => ({
      ...appState,
      newUnrecognizedInterestForm: {
        ...appState.newUnrecognizedInterestForm,
        interestName: interestName,
      },
    }));
  }

  function updateDebouncedInterestNameForFuzzyFilter(debouncedInterestNameForFuzzyFilter) {
    dispatch((appState) => ({
      ...appState,
      newUnrecognizedInterestForm: {
        ...appState.newUnrecognizedInterestForm,
        debouncedInterestNameForFuzzyFilter: debouncedInterestNameForFuzzyFilter,
      },
    }));
  }

  function getFeedbackFromLocalStorage(feedbackMessage, feedbackVariant) {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: feedbackMessage,
      feedbackVariant: feedbackVariant,
    }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    updateNewInterestName,
    updateDebouncedInterestNameForFuzzyFilter,
    getFeedbackFromLocalStorage,
    clearFeedback,
  };
}
